import type { App } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const store = createPinia()
store.use(piniaPluginPersistedstate)

// 一定要注意， 因为用了store的持久化， 所以仓库数据有问题的时候， 记得要清空
export const setupStore = (app: App<Element>) => {
  app.use(store)
}

export { store }
